import React, { Component } from 'react'
import WithReadonlyPatient from '../../conditions/WithReadonlyPatient'
import PatientSessionLayout from '../../layouts/PatientSessionLayout'
import GoalPage from './GoalPage'
import LearnPage from './LearnPage'
import UsePage from './UsePage'
import AdherencePage from "./AdherencePage";

export default class PatientSession extends Component {
  render() {
    const { match } = this.props
    const { page } = match.params

    return (
      <WithReadonlyPatient>
        <PatientSessionLayout title={`titles.${page}`}>
          {page === 'learn' && <LearnPage />}
          {page === 'use' && <UsePage />}
          {page === 'goal' && <GoalPage />}
          {page === 'adherence' && <AdherencePage />}
        </PatientSessionLayout>
      </WithReadonlyPatient>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/PatientSession/index.js